import { BooleanField } from "react-admin";

import { DataKind } from "../../types";
import { CustomDateTimeField, CustomShow, ShowTable } from "../custom";

function OtcMaintenanceWindowShow() {
  return (
    <CustomShow
      checkPermissionFor={DataKind.OtcMaintenanceWindow}
      displayDelete={false}
      displayEdit={true}
    >
      <ShowTable title="OTC Maintenance Window Details">
        <CustomDateTimeField label="Start Time(UTC)" source="start_time" />
        <BooleanField label="Completed" source="completed" />
      </ShowTable>
    </CustomShow>
  );
}

export default OtcMaintenanceWindowShow;
